@if (musicCollection != null) {
  <div class="content-wrapper">
    <div class="title-container">
      @if (isPlaylist) {
        <tun-tweak-playlist-icon-v5 class="icon icon-scaled-svg-button"></tun-tweak-playlist-icon-v5>
      }
      @if (isContext) {
        <tun-tweak-context-icon-v5 class="icon icon-scaled-svg-button"></tun-tweak-context-icon-v5>
      }
      <div class="title">{{musicCollection.title}}</div>
      @if (tweakInfoLoaded) {
        <tun-tweak-strength-bar-v5
          [class.disabled]="tweakInfoLoading"
          [percentage]="tweakInfo?.percentage || 0"
          [status]="tweakInfo?.status"
        ></tun-tweak-strength-bar-v5>
      }
      @if (isContext) {
        <button
          class="resetButton"
          (click)="onReset()"
          >
          Reset
        </button>
      }
      <button class="icon-button" (click)="onClose()">
        <tun-close-v5 class="icon close-icon icon-large-scaled-svg-button"></tun-close-v5>
      </button>
    </div>
    <div class="seperator"></div>
    @if (musicCollection.detailsLoading) {
      <div
        class="feedback-container"
        >
        <tun-loader-v5 class="loader"></tun-loader-v5>
      </div>
    }
    @if (musicCollection.detailsLoadingError != null) {
      <div
        class="error-feedback-container"
        >
        <p>
          {{'general.status.error.message' | translate }}
        </p>
        <button (click)="retryClick()" class="retryButton">
          <p>
            {{'general.status.error.retry' | translate }}
          </p>
        </button>
      </div>
    }
    @if (!musicCollection.detailsLoading && musicCollection.detailsLoadingError == null) {
      @if (isContext) {
        <tun-changeable-parameters-panel-v5
          [changeableParameters]="changeableParameters"
          (parameterchange)="onParameterChange()"
          class="content"
        ></tun-changeable-parameters-panel-v5>
      }
      @if (isPlaylist) {
        <tun-track-list-view
          [tracks]="tracks"
          class="content"
          [tunifyColor]="TunifyColor.BLUE"
          >
        </tun-track-list-view>
      }
    }
  </div>
}
